import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import FileUpload from "components/FileUpload/FileUpload";
import DefaultCheque from "assets/img/default-avatar.png";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import BankInformationUI from "./BankInformationUi";
import OtpModal from "../OtpModal/OtpModal";
import { Button, Grid } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { useOutletContext } from "react-router-dom";
import { parseAndSetFlag } from "utils/Utils";
import { removeSpecialCharFileName } from "utils/Utils";
import { loanApplicationStatus } from "assets/properties/properties";
import { headerLabel } from "assets/properties/properties";
const BankInformationPre = ({
  setNext,
  setBack,
  loanApplicationId,
  editable,
  status,
  applicantDetails,
  classes,
  mobileNum,
  yearlyCashValue,
  financialYearCashValidationFlag,
  detailsFullFiled,
  featureFlags
}) => {
  let fileUploadComponent = useRef();
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [bankaccount, setBankAccount] = useState("");
  const [bankaccountState, setBankaccountState] = useState(false);
  const [bankaccountErrorMsg, setBankaccountErrorMsg] = useState("");
  const [ifsccode, setIFSCCODE] = useState("");
  const [ifsccodeState, setIFSCcodeState] = useState(false);
  const [ifsccodeErrorMsg, setIFSCcodeErrorMsg] = useState("");
  const [isBankValidate, setIsBankValidate] = useState("");
  const [imagefile, setImagefile] = useState("");
  const [isBankAvailable, setIsBankAvailable] = useState(true);
  const [isBankDetailsPresent, setIsBankDetailsPresent] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [chequeNumber, setCheckqueNumber]= useState("")
  const [callInProgress, setCallInProgress] = useState(false);
  const [inputFields, setInputFields] = useState({
    Bank: "",
    Branch: "",
    State: "",
    Address: "",
  });
  const [accountDetailFileds, setAccountDetailFields] = useState({
    Status: "",
    BeneficiaryName: "",
    MatchingPercentage: "",
    Id: "",
    Message: "",
    MessageCode: "",
  });
  const [msg, setMsg] = useState("");
  const [head, setHead] = useState("");
  const [show, setShow] = useState(false);
  const [actualLoanAmount, setActualLoanAmount] = useState("");
  const [isBankVerified, setIsBankVerified] = useState(false);
  const outletData = featureFlags;
  const skipChequeNumberFiled = parseAndSetFlag(outletData.skipChequeNumberFiled)
  const hideMatchingPercentageFlag = parseAndSetFlag(outletData.hideMatchingPercentageFlag);
  const maxAccountMatchingPercentageFlag = outletData.maxAccountMatchingPercentageFlag;
  const validateThirdPartyAttemptsFlag = parseAndSetFlag(outletData?.validateThirdPartyAttemptsFlag);
  const enabledV2InprocessTab = parseAndSetFlag(
      outletData?.enabledV2InprocessTab
    );
  const [accountType,setAccountType]=useState("")
  const [accountTypeState,setAccountTypeState]=useState("")
  const accountTypeList = [
    {code:"SAVING",name:"Saving"},
    {code:"CURRENT",name:"Current"},
  ]
  const [ifscValidate, setIfscValidate]=useState(false);
  const [showModal, setShowModal] = useState(false);
  const [featureFlag,setFeatureaFlag]=useState({});
  const [disabledField, setDisabledField] = useState(true);
  const [disabledFieldBank, setDisabledFieldBank] = useState(true);
  const mobileNumber = applicantDetails?.mobileNumber || mobileNum
  const [bankVerifiedAttepmted, setBankVerifiedAttepmted] = useState({
      success:false,
      error:false,
    });
  const [ifscValidateAttempted, setIfscValidateAttempted]=useState({
      success:false,
      error:false,
    })
    const [bankState,setBankState] = useState(false);
    const [branchState,setBranchState] = useState(false);
    const [stateState,setStateState] = useState(false);
    const [addressState,setAddressState] = useState(false);
    const [StatusState,setStatusState] = useState(false);
    const [beneficiaryNameState,setBeneficiaryNameState] = useState(false);
    const [matchingPercentageState,setMatchingPercentageState] = useState(false);
  useEffect(() => {
    getFeatureFlag();
  }, []);
  const getFeatureFlag = async () => {
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
    });
    setFeatureaFlag(result?.data);
  };
  const PANCRITERIA = Number(yearlyCashValue);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const handleClose = () => {
    setShowModal(!showModal);
    setBankaccountState(true);
    setIsBankValidate(false);
    setIfscValidate(false);
  };
  useEffect(() => {
    if(PANCRITERIA >= 0 && !editable){GetAccountDetails();}
    if(editable && PANCRITERIA >= 0){
      GetActualLoanAmount();
      }
  }, [PANCRITERIA, editable]);
  const GetActualLoanAmount = async () => {
    const result = await apiHandler({
      url: endpoint.PawanTicket_Detials_get + loanApplicationId,
      authToken: authToken,
    });
    if (result?.data?.actualLoanAmount) {
      setActualLoanAmount(result?.data?.actualLoanAmount);
      GetAccountDetails(result?.data?.actualLoanAmount);
      if (result?.data?.actualLoanAmount > PANCRITERIA) {
        setIsBankAvailable(true);
      }
    }
  };
  
  const GetExistingBankDetails = async(btActualLoanAmount) => {
    const result = await apiHandler({
       url: endpoint.SEARCH_PROFILE + mobileNumber?.trim(),
      method: "GET",
      authToken: authToken,
    })
    if (Number(btActualLoanAmount) > PANCRITERIA) {
      setIsBankAvailable(true)
    }
    if(result?.data?.[0]?.bankDetailResponse?.bankName !== null && typeof result?.data?.[0]?.bankDetailResponse?.bankName !== 'undefined'){
       if(result?.data?.[0]?.bankDetailResponse?.verified){
              setBankVerifiedAttepmted({success:true});
              setIfscValidateAttempted({success:true});
            }
        if(!result?.data?.[0]?.bankDetailResponse?.verified){
              setBankVerifiedAttepmted({error:true});
              setIfscValidateAttempted({error:true});
            }
        setInputFields({
          Bank: result?.data?.[0]?.bankDetailResponse?.bankName,
          Branch: result?.data?.[0]?.bankDetailResponse?.branch,
          Address: result?.data?.[0]?.bankDetailResponse?.address,
          State: result?.data?.[0]?.bankDetailResponse?.state,
        });
        setAccountDetailFields({
          Status: result?.data?.[0]?.bankDetailResponse?.status,
          BeneficiaryName: result?.data?.[0]?.bankDetailResponse?.beneficiaryName,
          MatchingPercentage: result?.data?.[0]?.bankDetailResponse?.matchingPercentage?.toString(),
        })
        setBankAccount(result?.data?.[0]?.bankDetailResponse?.accountNumber);
        setCheckqueNumber(result.data?.[0]?.bankDetailResponse?.chequeNumber)
        setAccountType(result?.data?.[0]?.bankDetailResponse?.accountType);
        setIsBankValidate(false);
        setIfscValidate(false);
        setIFSCCODE(result?.data?.[0]?.bankDetailResponse?.ifscCode);
        if (result?.data?.[0]?.bankDetailResponse?.ifscCode) {
          setIFSCcodeState(false);
        }
        if (result?.data?.[0]?.bankDetailResponse?.accountNumber) {
          setBankaccountState(false);
        }
        setImagefile(result?.data?.[0]?.bankDetailResponse?.checkLink);
        ActualLoanAmount(true);
      }
    
  }
  useEffect(()=>{
    if(!isBankAvailable){
      setInputFields({
        Bank: "",
        Branch: "",
        Address: "",
        State:  "",
      });
      setAccountDetailFields({
        Status: "",
        BeneficiaryName: " ",
        MatchingPercentage:  "",
      })
      setBankAccount("");
      setIFSCCODE("");
      setImagefile("");
      setAccountType("");
      setCheckqueNumber("")
    }
  },[isBankAvailable])
  const GetAccountDetails = async (btActualLoanAmount) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url:
        endpoint.BANKINFORMATION_GETDATA +
        "?" +
        "applicationId=" +
        loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code === 404) {
      if(editable) { GetExistingBankDetails(btActualLoanAmount);}else{
      setIsBankAvailable(false)
    }
    }else if (result?.data?.error_code) {
      if(editable){GetExistingBankDetails(btActualLoanAmount);}else{
      setIsBankAvailable(false)
    }
    } else {
      setInputFields({
        Bank: result?.data?.bankName,
        Branch: result?.data?.branch,
        Address: result?.data?.address,
        State: result?.data?.state,
      });
      setAccountDetailFields({
        Status: result?.data?.status,
        BeneficiaryName: result?.data?.beneficiaryName,
        MatchingPercentage: result?.data?.matchingPercentage?.toString(),
      });
      setIsBankVerified(result?.data?.verified);
      setCheckqueNumber(result?.data?.chequeNumber)
      setBankAccount(result?.data?.accountNumber);
      setAccountType(result?.data?.accountType);
      setIsBankValidate(true);
       if(result?.data?.verified){
        setBankVerifiedAttepmted({success:true});
        setIfscValidateAttempted({success:true});
      }
                  if(!result?.data?.verified){
         setBankVerifiedAttepmted({error:true});
        setIfscValidateAttempted({error:true});
      }
      setIfscValidate(true);
      setIFSCCODE(result?.data?.ifscCode);
      if (result?.data?.ifscCode) {
        setIFSCcodeState(false);
      }
      if (result?.data?.accountNumber) {
        setBankaccountState(false);
        setIsBankDetailsPresent(true);
      }
      setImagefile(result?.data?.checkLink);
      ActualLoanAmount(true, result?.data?.accountNumber);
    }
    if(!result?.data?.accountNumber && !editable){
      setIsBankAvailable(false)
      setIsBankDetailsPresent(false);
    }
  };

  const ActualLoanAmount = async (isbankInformationAvailable, accountNumber) => {
    if(!accountNumber && !editable){
      setIsBankAvailable(false);
    } else{
      setIsBankAvailable(isbankInformationAvailable);
    }
  };

  const isValidated = () => {
    if (actualLoanAmount > PANCRITERIA) {
      if (
        ifsccode === "" ||
        typeof ifsccode === "undefined" ||
        ifsccode === null
      ) {
        setIFSCcodeState(true);
      } else {
        setIFSCcodeState(false);
      }
      if (
        bankaccount === "" ||
        typeof bankaccount === "undefined" ||
        bankaccount === null
      ) {
        setBankaccountState(true);
      } else {
        setBankaccountState(false);
      }
      if(accountType === "" || typeof accountType === "undefined" || accountType === null){
        setAccountTypeState(true);
      }else{
        setAccountTypeState(false);
      }
      if(isBankValidate === false){
        toastUpdate("Error", "Please Validate Bank Account Number", true);

      }
      if(ifscValidate === false){
        toastUpdate("Error", "Please Validate IFSC Code", true);
      }
      if(Number(accountDetailFileds.MatchingPercentage) < Number(maxAccountMatchingPercentageFlag) && (imagefile === "" || imagefile === null) ){
        toastUpdate("Error","Please Upload The Bank Documents", true);

        return false;
      }
      setBankState(inputFields?.Bank === '' || inputFields?.Bank === undefined || inputFields?.Bank === null);
      setBranchState(inputFields?.Branch === '' || inputFields?.Branch === undefined || inputFields?.Branch === null);
      setStateState(inputFields?.State === '' || inputFields?.State === undefined || inputFields?.State === null);
      setAddressState(inputFields?.Address === '' || inputFields?.Address === undefined || inputFields?.Address === null);
      setStatusState(accountDetailFileds?.Status === '' || accountDetailFileds?.Status === undefined || accountDetailFileds?.Status === null);
      setBeneficiaryNameState(accountDetailFileds?.BeneficiaryName === '' || accountDetailFileds?.BeneficiaryName === undefined || accountDetailFileds?.BeneficiaryName === null);
      setMatchingPercentageState(accountDetailFileds?.MatchingPercentage === '' || accountDetailFileds?.MatchingPercentage === undefined || accountDetailFileds?.MatchingPercentage === null);
      if (
        ifsccode &&
        ifsccode !== "" &&
        ifsccodeState === false &&
        bankaccount &&
        bankaccount !== "" &&
        accountType &&
        accountType !== "" &&
        bankaccountState === false &&
        isBankValidate === true  && 
        ifscValidate === true &&
        inputFields.Bank &&
        inputFields.Branch &&
        inputFields.State &&
        inputFields.Address &&
        accountDetailFileds.Status &&
        accountDetailFileds.BeneficiaryName &&
        accountDetailFileds.MatchingPercentage
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (!isBankAvailable) {
        return true;
      } else {
        if (
          ifsccode === "" ||
          typeof ifsccode === "undefined" ||
          ifsccode === null
        ) {
          setIFSCcodeState(true);
        } else {
          setIFSCcodeState(false);
        }
        if(accountType === "" || typeof accountType === "undefined" || accountType === null){
          setAccountTypeState(true);
        }else{
          setAccountTypeState(false);
        }
        if (
          bankaccount === "" ||
          typeof bankaccount === "undefined" ||
          bankaccount === null
        ) {
          setBankaccountState(true);
        } else {
          setBankaccountState(false);
        }
        if(isBankValidate === false){
          toastUpdate("Error", "Please Validate Bank Account Number", true);

        }
        if(ifscValidate === false){
          toastUpdate("Error","Please Validate IFSC Code", true);
        }
        if(Number(accountDetailFileds.MatchingPercentage) < Number(maxAccountMatchingPercentageFlag) && (imagefile === "" || imagefile === null)){
          toastUpdate("Error","Please Upload The Bank Documents", true);

        return false;
      }
      setBankState(inputFields?.Bank === '' || inputFields?.Bank === undefined || inputFields?.Bank === null);
      setBranchState(inputFields?.Branch === '' || inputFields?.Branch === undefined || inputFields?.Branch === null);
      setStateState(inputFields?.State === '' || inputFields?.State === undefined || inputFields?.State === null);
      setAddressState(inputFields?.Address === '' || inputFields?.Address === undefined || inputFields?.Address === null);
      setStatusState(accountDetailFileds?.Status === '' || accountDetailFileds?.Status === undefined || accountDetailFileds?.Status === null);
      setBeneficiaryNameState(accountDetailFileds?.BeneficiaryName === '' || accountDetailFileds?.BeneficiaryName === undefined || accountDetailFileds?.BeneficiaryName === null);
      setMatchingPercentageState(accountDetailFileds?.MatchingPercentage === '' || accountDetailFileds?.MatchingPercentage === undefined || accountDetailFileds?.MatchingPercentage === null);
        return (
          ifsccode &&
          ifsccode !== "" &&
          ifsccodeState === false &&
          bankaccount &&
          bankaccount !== "" &&
          accountType &&
          accountType !== "" &&
          bankaccountState === false &&
          isBankAvailable === true &&
          isBankValidate === true &&
          ifscValidate === true &&
          inputFields.Bank &&
          inputFields.Branch &&
          inputFields.State &&
          inputFields.Address &&
          accountDetailFileds.Status &&
          accountDetailFileds.BeneficiaryName &&
          accountDetailFileds.MatchingPercentage
        );
      }
    }
  };

  const handlecreateuserSubmit = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (isValidated()) {
      if(isBankAvailable){
        setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.BANKNFORMATION_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          loanApplicationId: loanApplicationId,
          bankName: inputFields?.Bank ? inputFields.Bank : null,
          accountNumber: bankaccount && bankaccount !== "" ? bankaccount : null,
          branch: inputFields?.Branch ? inputFields.Branch : null,
          ifscCode: ifsccode && ifsccode !== "" ? ifsccode?.toUpperCase() : null,
          checkLink: imagefile && imagefile !== "" ? imagefile : null,
          state: inputFields?.State ? inputFields?.State : null,
          address: inputFields?.Address ? inputFields?.Address : null,
          chequeNumber:chequeNumber,
          status: accountDetailFileds?.Status
            ? accountDetailFileds?.Status
            : null,
            beneficiaryName: accountDetailFileds?.BeneficiaryName
            ? accountDetailFileds?.BeneficiaryName
            : null,
          matchingPercentage: accountDetailFileds?.MatchingPercentage
            ? Number(accountDetailFileds?.MatchingPercentage)
            : null,
          accountType:accountType && accountType !== "" ? accountType : null,
          verified:isBankVerified,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code && res?.data?.error_code === 403) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        if (fileUploadComponent && fileUploadComponent.current) {
          fileUploadComponent.current.handleRemove();
        }
        setNext();
      }
    }else{
        setNext();
      }
    }
  };

  // cancel button function
  const handleBack = () => {
    if (fileUploadComponent && fileUploadComponent.current) {
      fileUploadComponent.current.handleRemove();
    }
    setBack();
  };

  const Uploadcheque = async (file) => {
    if (isBankAvailable) {
      if (file) {
        setCallInProgress(true);
        const formData = new FormData();
        const fileName = removeSpecialCharFileName(file.name)
        formData.append("file", file, fileName);
        const path = await apiHandler({
          url: endpoint.FILE_UPLOAD,
          method: "POST",
          authToken: authToken,
          data: formData,
        });
        const uploadedPath = path.data;
        setCallInProgress(false);
        setImagefile(uploadedPath.name);
      } else {
        toastUpdate("Error", "Upload Cheque Before Submited", true);

      }
    }
  };
  const handlenext = () => {
    setNext();
  };
  const back = () => {
    setBack();
  };
  // get details with IFSC code
  const ifscCodeHandler = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.IFSC_CODE + ifsccode?.toUpperCase(),
      authToken: authToken,
    });
    setCallInProgress(false);
    const data = res?.data;
    if ((data?.error_code || data === null || data === undefined || data?.BANK === null || data?.BANK === undefined) && parseAndSetFlag(featureFlag?.enabledManualIfscDetails)) {
      setIFSCcodeState(false);
      setDisabledField(false);
      setIfscValidate(true);
      setIfscValidateAttempted({success:true});
    }else if (res?.data?.error_code) {
      toastUpdate("Error", "Please fill the correct IFSC code", true);
      setIFSCcodeState(true);
      setIfscValidate(false);
      setIfscValidateAttempted({error:true});
      return;
    } else {
      setIfscValidateAttempted({success:true});
      setIFSCcodeState(false);
      setDisabledField(true);
      setIfscValidate(true);
      setInputFields({
        Bank: data?.BANK,
        Branch: data?.BRANCH,
        State: data?.STATE,
        Address: data?.ADDRESS,
      });
    }
  };
  // Get Account details with Account Number
  const AccountValidater = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.PENNY_DROP,
      method: "POST",
      authToken: authToken,
      data: {
        beneficiaryName:
          (applicantDetails?.nameOnAdhaar && applicantDetails.nameOnAdhaar) ||
          applicantDetails?.nameOnPanCard || null,
        ifsc: ifsccode && ifsccode !== "" ? ifsccode?.toUpperCase() : null,
        accountNo: bankaccount && bankaccount !== "" ? bankaccount : null,
        mobileNumber:
          (mobileNumber && mobileNumber?.trim()) ||
          null,
      },
    });
    setCallInProgress(false);
      if(res?.data?.status === "OTP_VALIDATION"){
        setAccountDetailFields({
          Status: res?.data?.status,
          BeneficiaryName: res?.data?.beneficiaryName,
          MatchingPercentage: res?.data?.matchingPercentage?.toString(),
          Id: res?.data?.id,
          Message: res.data?.message,
          MessageCode: res?.data?.messageCode,
        });
        setShowModal(true);
    }else if (res?.data?.status === "REALIZED"){
      setBankVerifiedAttepmted({success:true});
      setAccountDetailFields({
        Status: res?.data?.status,
        BeneficiaryName: res?.data?.beneficiaryName,
        MatchingPercentage: res?.data?.matchingPercentage?.toString(),
        Id: res?.data?.id,
        Message: res.data?.message,
        MessageCode: res?.data?.messageCode,
      });
      setIsBankValidate(true);
      setBankaccountState(false);
      setShowModal(false);

       if((res?.data?.beneficiaryName === "" || !res?.data?.beneficiaryName) && parseAndSetFlag(featureFlag?.enableManualBankDetailsFlag)){
      setDisabledFieldBank(false);
      setIsBankVerified(false);
    }else{
      setDisabledFieldBank(true);
      setIsBankVerified(true);
      }
    }else if (parseAndSetFlag(featureFlag?.enableManualBankDetailsFlag) &&  (res?.data?.status === "ERROR" || res?.data?.error_code)){
      setDisabledFieldBank(false);
      setIsBankValidate(true);
      setBankaccountState(false);
      setShowModal(false)
      setIsBankVerified(false);
      setBankVerifiedAttepmted({error:true});
     setAccountDetailFields({
        Status: "Error",
        MatchingPercentage: "0",
        BeneficiaryName: applicantDetails?.nameOnAdhaar || applicantDetails?.nameOnPanCard,
      });
    }else {
      setCallInProgress(false);
      toastUpdate("Error", "Please Validate Bank Account Number", true);
      setBankaccountState(true);
      setDisabledFieldBank(true);
      setBankVerifiedAttepmted({error:true});
    }
  };
  const Otp = async (code1) => {
    setCallInProgress(true);
    const response = await apiHandler({
      url: endpoint.OTP_CODE,
      method: "PUT",
      authToken: authToken,
      data: {
        id: accountDetailFileds?.Id,
        otp: code1,
      },
    });
    setCallInProgress(false);
    if (response?.data?.error_code) {
      toastUpdate("Error",'Kindly verify the otp or resend the otp', true);
      setIsBankValidate(false);
      setBankVerifiedAttepmted({error:true});
    } else {
      setShowModal(false);
      setBankVerifiedAttepmted({success:true});
      setAccountDetailFields({
        Status: response?.data?.status,
        BeneficiaryName: response?.data?.beneficiaryName,
        MatchingPercentage: response?.data?.matchingPercentage?.toString(),
      });
      setIsBankVerified(true);
      setIsBankValidate(true);
      setBankaccountState(false);
    }
  };
  const ResendOtp = async () => {
    setCallInProgress(true);
    const otpResponse = await apiHandler({
      url: endpoint.RESEND_OTP + accountDetailFileds?.Id,
      method: "PUT",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (otpResponse?.data?.error_code) {
      toastUpdate("Error", "Please fill the correct Account Number", true);

      setCallInProgress(false);
      return;
    } else {
      setMsg("OTP Sent Successfully");
      setHead("Information");
      setShow(true);
    }
  };
  const handleSwitchChange = () => {
    setIsBankAvailable(!isBankAvailable);
  };
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setInputFields((prevFields) => ({
      ...prevFields,
      [id]: value, // Update the correct field by id
    }));
  };
  const handleInputChangeBank = (e) => {
    const { id, value } = e.target;
    setAccountDetailFields((prevFields) => ({
      ...prevFields,
      [id]: value, // Update the correct field by id
    }));
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
           <SubHeader
               label={headerLabel?.bank}
               subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
               onlyLabel
           />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid
          container
          className={classes.inputFieldContainer}
          style={{ display: "block" }}
        >
          <Grid>
            <Grid xs={3} sm={3} md={3} lg={3} style={{ display: "flex" }}>
              <lable style={{ marginTop: 6, marginRight: 22 }}>Cash</lable>
              <FormControlLabel
                control={
                  <Switch
                    checked={isBankAvailable}
                    onChange={handleSwitchChange}
                    name="checkedB"
                    color="primary"
                    disabled={!editable || actualLoanAmount > PANCRITERIA || isBankDetailsPresent}
                  />
                }
              />
              <lable style={{ marginTop: 10 }}>Bank</lable>
            </Grid>
          </Grid>
          {isBankAvailable && (
            <Grid>
              <BankInformationUI
                inputFields={inputFields}
                ifscCodeHandler={ifscCodeHandler}
                ifsccodeState={ifsccodeState}
                ifsccodeErrorMsg={ifsccodeErrorMsg}
                ifsccode={ifsccode}
                setIFSCCODE={setIFSCCODE}
                setIFSCcodeErrorMsg={setIFSCcodeErrorMsg}
                editable={editable}
                classes={classes}
                bankaccountState={bankaccountState}
                bankaccount={bankaccount}
                bankaccountErrorMsg={bankaccountErrorMsg}
                setBankAccount={setBankAccount}
                setBankaccountState={setBankaccountState}
                setBankaccountErrorMsg={setBankaccountErrorMsg}
                AccountValidater={AccountValidater}
                accountDetailFileds={accountDetailFileds}
                setIFSCcodeState={setIFSCcodeState}
                setInputFields={setInputFields}
                setAccountDetailFields={setAccountDetailFields}
                accountType={accountType}
                setAccountType={setAccountType}
                accountTypeState={accountTypeState}
                setAccountTypeState={setAccountTypeState}
                accountTypeList={accountTypeList}
                hideMatchingPercentageFlag={hideMatchingPercentageFlag}
                chequeNumber={chequeNumber}
                setCheckqueNumber={setCheckqueNumber}
                skipChequeNumberFiled={skipChequeNumberFiled}
                disabledField={disabledField}
                disabledFieldBank={disabledFieldBank}
                handleInputChange={handleInputChange}
                handleInputChangeBank={handleInputChangeBank}
                 ifscValidate={ifscValidate}
                isBankVerified={isBankVerified}
                ifscValidateAttempted={ifscValidateAttempted}
                bankVerifiedAttepmted={bankVerifiedAttepmted}
                bankState={bankState}
                branchState={branchState}
                stateState={stateState}
                addressState={addressState}
                StatusState={StatusState}
                beneficiaryNameState={beneficiaryNameState}
                matchingPercentageState={matchingPercentageState}
                validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
              />
              <Grid
                xs={10}
                sm={10}
                md={10}
                lg={10}
                style={{ textAlign: "start", margin: "2%" }}
              >
                {" "}
                {/* {isBankAvailable === "false" && ( */}
                <>
                  <label className={classes.uploadLabel}>
                    Screenshot of Cheque
                  </label>
                  {editable === true ? (
                    <>
                      {imagefile !== "" && (
                        <div>
                          <img
                            src={imagefile ? imagefile : DefaultCheque}
                            width={200}
                            height={100}
                            alt="default cheque"
                          />
                        </div>
                      )}
                      <FileUpload
                        supportedMimeType={[
                          "image/jpeg",
                          "image/bmp",
                          "image/png",
                          "image/tiff",
                        ]}
                        addButtonProps={{
                          color: "info",
                          round: false,
                        }}
                        changeButtonProps={{
                          color: "info",
                          round: false,
                        }}
                        removeButtonProps={{
                          color: "danger",
                          round: false,
                        }}
                        sendFile={(file) => {
                          Uploadcheque(file);
                        }}
                        ref={fileUploadComponent}
                        classes={classes}
                        noPreview
                      />
                    </>
                  ) : (
                    <img
                      alt="screenshotimage"
                      src={imagefile}
                      width={200}
                      height={100}
                      style={{ margin: " 10px 0 0 10px" }}
                    />
                  )}
                </>
              </Grid>
            </Grid>
          )}
          {enabledV2InprocessTab && !isBankAvailable && (
            <Grid item xs={12} style={{ textAlign: "end" }}>
              <Typography
                variant="body2"
                style={{
                  color: "#d32f2f",
                  fontWeight: 500,
                  backgroundColor: "#fff3f3",
                  padding: "8px 12px",
                  borderRadius: "6px",
                  display: "inline-block",
                }}
              >
                You won't be able to take a loan of more than ₹19,999.
              </Typography>
            </Grid>
          )}
          {status === loanApplicationStatus?.inProcess || status === loanApplicationStatus?.aadhaar || status === loanApplicationStatus?.selfie? (
            <Grid item xs={12} sm={12} md={12} style={{ textAlign: "end" }}>
              <Button
                size="small"
                className={classes.nextButton1}
                onClick={() => handleBack()}
              >
                Back
              </Button>
              <Button
                size="small"
                className={classes.nextButton}
                disabled={callInProgress || !detailsFullFiled}
                onClick={(event) => handlecreateuserSubmit(event)}
              >
                Next
              </Button>
            </Grid>
          ) : (
            <Grid
              xs={12}
              sm={12}
              md={12}
              style={{
                textAlign: window.innerWidth > 600 ? "end" : "center",
              }}
            >
              <Button
                size="small"
                className={classes.nextButton1}
                disabled={callInProgress}
                onClick={() => back()}
              >
                Back
              </Button>
              <Button
                size="small"
                className={classes.nextButton}
                disabled={callInProgress}
                onClick={() => handlenext()}
              >
                Next
              </Button>
            </Grid>
          )}
        </Grid>
        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
        {showModal && (
          <OtpModal
            handleClose={handleClose}
            showModal={showModal}
            Otp={Otp}
            ResendOtp={ResendOtp}
            message={msg}
            header={head}
            show={show}
          />
        )}
      </Grid>
    </Grid>
  );
};
BankInformationPre.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  editable: PropTypes.object,
};
export default BankInformationPre;